// edit: zhangmyh 2017-8-23 11:16 PM

function formTextarea (params) {
  this.id = params.id || 'formeditor'
  this.displayName = params.displayName || '字段'
  this.required = params.required || false
  this.maxlength = params.maxlength || 2000
  this.model = params.model
  this.field = params.field
  this.placeholder = params.placeholder
  this.readonly = !!(params.readonly)

  let tiplist = []
  if (params.tip) {
    if (typeof params.tip == 'string') {
      if (params.tip != '') {
        tiplist.push(params.tip)
      }
    } else if (typeof params.tip == 'object') {
      let tip
      if (params.tip[params.field]) {
        tip = params.tip[params.field]

        if (typeof tip == 'string') {
          if (tip != '') {
            tiplist.push(tip)
          }
        } else if (typeof tip == 'object') {
          if (tip.length > 0) {
            tiplist = tip
          }
        }
      } else if (params.tip.length > 0) {
        tiplist = params.tip
      }
    }
  }
  this.tip = tiplist
  this.hasTip = (tiplist.length > 0)
  this.model = params.model
  this.field = params.field
}

export default formTextarea



// WEBPACK FOOTER //
// ./src/components/ag-form/form-textarea/index.js